<!-- Center canvas: summary, text typed into directly - whole card is one pinnable region -->
<div class="cr-gv-card" *ngIf="isPreview" [id]="block.blockId">
  <span class="cr-gv-badge">Gift Voucher CTA</span>

  <div class="cr-gv-row">
    <div
      class="cr-gv-dropzone"
      [appInlineMedia]="block.variables?.['GiftVoucherImage']"
      [inlineMediaBlockId]="block.blockId"
      (inlineMediaChange)="onChange($event, 'GiftVoucherImage')"
    >
      <a *ngIf="block.variables?.['GiftVoucherImage']; else emptyPreview" [href]="imagePreviewHref" target="_blank" rel="noopener">
        <img [src]="block.variables?.['GiftVoucherImage']" [alt]="block.variables?.['GiftVoucherImageAlt'] || ''" />
      </a>

      <ng-template #emptyPreview>
        <div class="cr-inline-media-icon">
          <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
            <path d="M7.4 18.3H6.2a4.2 4.2 0 0 1-.45-8.38A6.25 6.25 0 0 1 17.83 8.7a4.85 4.85 0 0 1 .02 9.6H16.6" />
            <path d="M12 19.2V11.7" />
            <path d="m8.9 14.8 3.1-3.1 3.1 3.1" />
          </svg>
        </div>
        <div class="cr-inline-media-title">Upload image</div>
        <div class="cr-inline-media-subtitle">PNG up to 2 mb</div>
      </ng-template>
    </div>

    <div class="cr-gv-content">
      <span
        class="cr-gv-heading"
        [appInlineEdit]="block.variables?.GiftVoucherHeading ?? ''"
        [inlineEditBlockId]="block.blockId"
        inlineEditPlaceholder="Insert heading"
        (inlineEditChange)="onChange($event, 'GiftVoucherHeading')"
      ></span>

      <span
        class="cr-gv-text"
        [appInlineEdit]="block.variables?.GiftVoucherText ?? ''"
        [inlineEditBlockId]="block.blockId"
        inlineEditPlaceholder="Insert text"
        [inlineEditMultiline]="true"
        (inlineEditChange)="onChange($event, 'GiftVoucherText')"
      ></span>

      <a class="cr-gv-cta" [href]="ctaPreviewHref" target="_blank" rel="noopener">
        <span
          [appInlineEdit]="block.variables?.GiftVoucherCtaText ?? ''"
          [inlineEditBlockId]="block.blockId"
          [inlineEditPlaceholder]="ctaButtonPlaceholder"
          (inlineEditChange)="onChange($event, 'GiftVoucherCtaText')"
        ></span>
      </a>
    </div>
  </div>
</div>

<!-- Right panel: real edit form -->
<div class="cr-gv-edit" *ngIf="!isPreview">
  <div class="cr-gv-field-row">
    <span class="cr-gv-field-label">Image</span>
    <span
      class="cr-gv-toggle"
      [class.cr-gv-toggle-on]="imageAsUpload"
      role="button"
      tabindex="0"
      [title]="imageAsUpload ? 'Switch to entering an image link' : 'Switch to uploading an image'"
      (click)="toggleImageMode()"
      (keydown.enter)="toggleImageMode()"
      (keydown.space)="toggleImageMode()"
    ></span>
  </div>
  <div class="cr-gv-image-field">
    <app-block-text
      [maxLength]="500"
      type="link"
      [blockData]="block.variables?.['GiftVoucherImage'] ?? ''"
      (handleOnChange)="onChange($event, 'GiftVoucherImage')"
      [placeholder]="imagePlaceholder"
      variable="GiftVoucherImage"
      [isImage]="imageAsUpload"
      [isPlainText]="true"
      [blockId]="block.blockId"
    ></app-block-text>
    <div class="cr-gv-empty-overlay" *ngIf="imageAsUpload && !block.variables?.['GiftVoucherImage']">
      <div class="cr-gv-icon">
        <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
          <path d="M7.4 18.3H6.2a4.2 4.2 0 0 1-.45-8.38A6.25 6.25 0 0 1 17.83 8.7a4.85 4.85 0 0 1 .02 9.6H16.6" />
          <path d="M12 19.2V11.7" />
          <path d="m8.9 14.8 3.1-3.1 3.1 3.1" />
        </svg>
      </div>
      <div class="cr-gv-title">Upload image</div>
      <div class="cr-gv-subtitle">PNG up to 2 mb</div>
    </div>
  </div>

  <div class="cr-gv-link-field">
    <app-field-editor-v2
      [maxLength]="500"
      type="action-link"
      [blockData]="block.variables?.['GiftVoucherImageHref'] ?? ''"
      (handleOnChange)="onChange($event, 'GiftVoucherImageHref')"
      [placeholder]="imageHrefPlaceholder"
      variable="GiftVoucherImageHref"
      (handleOnSegmentChange)="handleOnSegmentChange($event, 'GiftVoucherImageHrefSegmentRegex')"
      [selectedSegment]="block.variables?.['GiftVoucherImageHrefSegmentRegex'] ?? ''"
      [disabled]="disabled"
    ></app-field-editor-v2>
  </div>

  <app-field-editor-v2
    type="alt"
    [blockData]="block.variables?.['GiftVoucherImageAlt'] ?? ''"
    (handleOnChange)="onChange($event, 'GiftVoucherImageAlt')"
    [placeholder]="imageAltPlaceholder"
    [maxLength]="500"
    variable="GiftVoucherImageAlt"
    [disabled]="disabled"
  ></app-field-editor-v2>

  <app-field-editor-v2
    type="content"
    [blockData]="block.variables?.['GiftVoucherHeading'] ?? ''"
    (handleOnChange)="onChange($event, 'GiftVoucherHeading')"
    [placeholder]="headingPlaceholder"
    [maxLength]="500"
    variable="GiftVoucherHeading"
    [disabled]="disabled"
  ></app-field-editor-v2>

  <app-field-editor-v2
    type="content"
    [multiline]="true"
    [showCounter]="true"
    [blockData]="block.variables?.['GiftVoucherText'] ?? ''"
    (handleOnChange)="onChange($event, 'GiftVoucherText')"
    [placeholder]="textPlaceholder"
    [maxLength]="4000"
    variable="GiftVoucherText"
    [disabled]="disabled"
  ></app-field-editor-v2>

  <div class="cr-gv-link-field">
    <app-field-editor-v2
      type="action-link"
      [blockData]="block.variables?.['GiftVoucherCtaLink'] ?? ''"
      (handleOnChange)="onChange($event, 'GiftVoucherCtaLink')"
      [placeholder]="ctaLinkPlaceholder"
      [maxLength]="500"
      variable="GiftVoucherCtaLink"
      (handleOnSegmentChange)="handleOnSegmentChange($event, 'GiftVoucherCtaLinkSegmentRegex')"
      [selectedSegment]="block.variables?.['GiftVoucherCtaLinkSegmentRegex'] ?? ''"
      [disabled]="disabled"
    ></app-field-editor-v2>
  </div>

  <app-field-editor-v2
    type="content"
    [blockData]="block.variables?.['GiftVoucherCtaText'] ?? ''"
    (handleOnChange)="onChange($event, 'GiftVoucherCtaText')"
    [placeholder]="ctaTextPlaceholder"
    [maxLength]="30"
    variable="GiftVoucherCtaText"
    [disabled]="disabled"
  ></app-field-editor-v2>
</div>
